import { Component, OnInit, Input, Injectable } from '@angular/core';
import { dataModel } from '../../models/data.model';


@Injectable({
  providedIn: 'root'
})

@Component({
  selector: 'app-footer',
  template: `<div class="full-wrapper">
              <p>{{ this.data.FooterCopyrights }}</p>
            </div>`,
  styleUrls: ['./footer.component.sass']
})
export class FooterComponent implements OnInit {
  @Input() data: dataModel;

  constructor() { }

  ngOnInit() {
  }
}
